import { Injectable } from '@angular/core';
import { IMatrixLayout } from '../../models/IMatrixLayout';

export interface IBoardConfig {
    numOfTiles: number;
    boardW: number;
    boardH: number;
    padding?: number;
    gap?: number;
}

@Injectable({
    providedIn: 'root',
})
export class FillBoardService {
    public getTileDimension(config: IBoardConfig): number {
        const { numOfTiles, gap } = config;
        const { boardW: paddedW, boardH: paddedH } = this.getPaddedWidHeight(config);
        let tileSide,
            actualColumns = numOfTiles,
            actualRows = 1,
            tilesInLastRow = 0;
        while (true) {
            const { realBoardW, realBoardH } = this.addGap(paddedW, paddedH, gap, actualColumns, actualRows);
            const newTileSide = realBoardW / actualColumns;
            if (newTileSide * actualRows > realBoardH) {
                return this.threeDecimals(tileSide ? tileSide : realBoardH);
            }
            tileSide = newTileSide;
            actualColumns--;
            tilesInLastRow += actualRows - 1;
            if (tilesInLastRow > actualColumns || actualRows === 1) {
                tilesInLastRow = 1;
                actualRows++;
            }
        }
    }

    public getMatrixFromNum(tilesNumber: number): IMatrixLayout {
        let columnNumber = 1;
        let rowNumber = 1;
        let i = 1;
        while (rowNumber * columnNumber < tilesNumber) {
            if (i % 2 === 0) {
                rowNumber++;
            } else {
                columnNumber++;
            }
            i++;
        }
        return {
            columnNumber,
            rowNumber,
        };
    }

    private getPaddedWidHeight(config: IBoardConfig): { boardW: number; boardH: number } {
        let { boardW, boardH, padding } = config;
        if (boardW === 0) {
            boardW = 1;
        }
        if (boardH === 0) {
            boardH = 1;
        }
        if (padding) {
            boardW = boardW - padding * 2;
            boardH = boardH - padding * 2;
        }
        return { boardH, boardW };
    }

    private addGap(
        boardW: number,
        boardH: number,
        gap: number,
        actualColumns: number,
        actualRows: number,
    ): { realBoardW: number; realBoardH: number } {
        let realBoardW, realBoardH;
        if (gap) {
            realBoardW = boardW - gap * (actualColumns - 1);
            realBoardH = boardH - gap * (actualRows - 1);
        } else {
            realBoardW = boardW;
            realBoardH = boardH;
        }
        return { realBoardW, realBoardH };
    }

    private threeDecimals(n: number): number {
        return Number(n.toString().slice(0, 6));
    }
}
